import { useMutation } from '@tanstack/react-query';
import { authApi } from '@/lib/api-client';

export function useRequestPasswordReset() {
  return useMutation({
    mutationFn: (data: { email: string }) =>
      authApi.post<{ data: { message: string; resetToken?: string } }>('/auth/password-reset/request', data),
  });
}

export function useResetPassword() {
  return useMutation({
    mutationFn: (data: { token: string; password: string }) =>
      authApi.post<{ data: { message: string } }>('/auth/password-reset/reset', data),
  });
}
